<script lang="ts">
	import Icon from "#lib/components/Icon.svelte";
	import P from "#lib/components/P.svelte";
</script>

<div class="flex h-full flex-col items-center justify-center gap-0.5 text-gray-500">
	<Icon iconSet="ph" name="image-broken" class="h-10 w-10" />
	<P size="sm">This image is unavailable.</P>
	<P size="sm">Please replace it with a new one.</P>
</div>
